import React from 'react';
import styled from 'styled-components/macro';
import { Layout, Error } from 'components/organisms';
import {
  HelperTitle, Text,
} from 'components/atoms';
import { Link } from 'react-router-dom';

const UnderDevelopment = () => (
  <Layout modifiers={['stretch']}>
    <Page>
      <Fullscreen>
        <Error
          message="Página em desenvolvimento"
          code={503}
          helper={(
            <Text>
              <Link to="/">Voltar à página inicial</Link>
            </Text>
          )}
        />
      </Fullscreen>
    </Page>
  </Layout>
);

const Fullscreen = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Page = styled.div`
  ${HelperTitle} {
    margin-bottom: ${props => props.theme.spacing.l};
  }
`;

export default UnderDevelopment;
